module.exports = __webpack_public_path__ + "img/F24-tunisia.5f801ce2.png";